import FacilityDistribution from './charts/FacilityDistribution'
import ServiceCoverageChart from './charts/ServiceCoverageChart'
import InfrastructureRadar from './charts/InfrastructureRadar'
import StaffingOverview from './charts/StaffingOverview'
import LocationRanking from './charts/LocationRanking'
import ServiceCoverageHeatmap from './charts/ServiceCoverageHeatmap'
import { sectionTemplates } from '../../utils/narrativeTemplates'

/**
 * HealthNarrativeContent - Health-specific visualizations and insights
 * Extracted from NarrativeDashboard for better maintainability
 */
function HealthNarrativeContent({ facilityData, narrativeData }) {
  return (
    <div className="space-y-6">
      {/* Facility Distribution */}
      <FacilityDistribution
        data={facilityData.metrics.facilityDistribution}
        title={sectionTemplates.facilityDistribution.title}
        templateText={sectionTemplates.facilityDistribution.description(
          facilityData.metrics
        )}
        narrative={
          narrativeData?.stories?.['healthcare-access']?.sections?.facility_mix
            ?.narrative
        }
      />

      {/* Service Coverage Analysis */}
      <ServiceCoverageChart
        data={facilityData.metrics.serviceCoverage}
        title={sectionTemplates.serviceCoverage.title}
        templateText={sectionTemplates.serviceCoverage.description(
          facilityData.metrics
        )}
        narrative={
          narrativeData?.stories?.['healthcare-access']?.sections
            ?.current_situation?.narrative
        }
      />

      {/* Infrastructure Readiness */}
      <InfrastructureRadar
        data={facilityData.metrics.infrastructureReadiness}
        gaps={facilityData.metrics.infrastructureGaps}
        title={sectionTemplates.infrastructureReadiness.title}
        templateText={sectionTemplates.infrastructureReadiness.description(
          facilityData.metrics
        )}
        narrative={
          narrativeData?.stories?.['healthcare-access']?.sections
            ?.infrastructure_readiness?.narrative
        }
      />

      {/* Staffing Overview */}
      <StaffingOverview
        data={facilityData.metrics.staffingDistribution}
        title={sectionTemplates.staffing.title}
        templateText={sectionTemplates.staffing.description(
          facilityData.metrics
        )}
        narrative={
          narrativeData?.stories?.['healthcare-access']?.sections?.staffing
            ?.narrative
        }
      />

      {/* Location Performance Comparison (if sub-locations available) */}
      {facilityData.subLocationComparisons && (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          {/* Section Header */}
          <div className="mb-6">
            <h2 className="text-xl font-bold text-gray-900 mb-2">
              {sectionTemplates.locationRanking.title(
                facilityData.subLocationComparisons.type
              )}
            </h2>

            {/* AI Narrative or Template Text */}
            {narrativeData?.stories?.['healthcare-access']?.sections
              ?.subcounty_comparison?.narrative ? (
              <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-4">
                <div className="flex items-start gap-2">
                  <span className="text-xl">💡</span>
                  <p className="text-sm text-gray-700 leading-relaxed">
                    {
                      narrativeData.stories['healthcare-access'].sections
                        .subcounty_comparison.narrative
                    }
                  </p>
                </div>
              </div>
            ) : (
              <p className="text-gray-600 text-sm mb-4">
                {sectionTemplates.locationRanking.description(
                  facilityData.subLocationComparisons
                )}
              </p>
            )}
          </div>

          {/* Rankings Table */}
          <div className="mb-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-3">
              Overall Performance Rankings
            </h3>
            <LocationRanking
              data={facilityData.subLocationComparisons}
              title=""
              templateText=""
              narrative=""
            />
          </div>

          {/* Service Coverage Heatmap */}
          <div>
            <h3 className="text-lg font-semibold text-gray-800 mb-3">
              Service Availability by Location
            </h3>
            <p className="text-sm text-gray-600 mb-3">
              {sectionTemplates.serviceHeatmap.description(
                facilityData.subLocationComparisons
              )}
            </p>
            <ServiceCoverageHeatmap
              data={facilityData.subLocationComparisons}
              title=""
              templateText=""
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default HealthNarrativeContent
